<script>
	import { createEventDispatcher } from 'svelte';
	import { person, logOut, helpCircleOutline, apps, search, settings as settingsIcon, pin, filing, stats } from 'ionicons/icons/index.mjs';
	import { getLocalServer } from '../shared/utils/Data.svelte';
	import List from './List.svelte';

  export let session;
  export let feature;
  export let keys;
  export let media;
	export let tooltips;
	
	const dispatch = createEventDispatcher();
	function sendMessage(message) {
		dispatch('message', message);
  }
</script>

<div id="tree" class="panel">
	<div class="panel-body">
		<List media={media} keys={keys} feature={feature} session={session} on:message />
	</div>
	<div class="panel-footer">
		<div class="tile tile-centered">
			<div class="tile-content">
				<div class="btn-group slant slant-right-reverse">
					<a class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" href="/" data-tooltip="Dashboard"><i class="svg svg-light">{@html person.md}</i></a>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Sign Out" on:click={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "session",
						data: {
							workspaces: ""
						}
					})
					}}><i class="svg svg-light">{@html logOut.md}</i></button>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Help" on:click={async (e) => {
						e.currentTarget.blur();
						if (window.platform == "Windows") {
							await fetch(getLocalServer() + "/help")
						}
						else {
							window.open("https://help.geosync.cloud");
						}
					}}><i class="svg svg-light">{@html helpCircleOutline.md}</i></button>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
  #tree {
      position: fixed;
      overflow-y: auto;
      width: 300px;
      height: 100%;
	}
	.panel {
        border: 0;
	}
	.panel .panel-body {
		padding: 0;
    }
	.panel .panel-footer {
		padding: 0;
		background: #efefef;
	}
	.svg {
		fill: #00ab5f;
	}
	.slant {
		color: white;
		background-color: #00ab5f;
		transform-origin: bottom left;
		position: relative;
		z-index: 1;
	}
	.slant-right-reverse:before {
		content: "";
		position: absolute;
		z-index: -1;
		top: 0;
		bottom: 0;
		right: 0;
		width: 20px;
		margin-right: -10px;
		background-color: #00ab5f;
		border-right: 2px solid #a9d9bb;
		-ms-transform: skew(30deg, 0deg);
		-webkit-transform: skew(30deg, 0deg);
		transform: skew(30deg, 0deg);
	}
	.slant .btn.btn-link {
		color: white;
	}
</style>
